<template>
  <v-card class="align-center pr-lg-12 pl-lg-12">   
    <v-card-title primary-title>
      <div class="text-h4">
        Historik  
      </div>
      <v-spacer />         
    </v-card-title>   
    <v-row>
      <v-col
        cols="12"
        sm="6"
        class="pl-6"
      >
        <v-dialog
          ref="dialog"
          v-model="modal"
          :return-value.sync="dates"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateRangeText"
              label="Datum intervall"
              prepend-icon="event"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="dates"
            range
            no-title
            show-adjacent-months
            :min="minDate"
            :max="maxDate"
            :first-day-of-week="1"
            locale="sv-se"
            prev-icon="mdi-skip-previous"
            next-icon="mdi-skip-next"
            color="primary lighten-1"
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="modal = false"
            >
              Avbryt
            </v-btn>
            <v-btn
              :disabled="validDates === false"
              text
              color="primary"
              @click="getNewData(dates)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
    </v-row>
    <v-container v-if="paperBundle.length > 0">
      <div class="text-h5">
        Huvudtidningar
      </div>
      <v-row v-if="$vuetify.breakpoint.mdAndUp" dense class="ma-1 text-h6 font-weight-light text-uppercase"> 
        <v-col cols="2">
          Title
        </v-col>
        <v-col cols="3">
          Utgåva
        </v-col>
        <v-col cols="2">
          Utgivningsdag          
        </v-col>
        <v-col cols="1">  
          Bunt
        </v-col>
        <v-col cols="1">
          Retur
        </v-col>      
        <v-col cols="1">
          Mottagit
        </v-col>              
        <v-col cols="2">
          Reklamerat
        </v-col>  
      </v-row>                      
      
      <template v-for="(bundle) in paperBundle">
        <BundleHistoric :key="bundle.returnReport.id" :bundle="bundle" />        
      </template>            
    </v-container>
    <v-container v-if="insertBundle.length > 0">
      <div class="text-h5">
        Bilagor
      </div>
      <v-row v-if="$vuetify.breakpoint.mdAndUp" dense class="ma-1 text-h6 font-weight-light text-uppercase"> 
        <v-col cols="2">
          Title
        </v-col>
        <v-col cols="3">
          Utgåva
        </v-col>
        <v-col cols="2">
          Utgivningsdag          
        </v-col>
        <v-col cols="1">  
          Bunt
        </v-col>
        <v-col cols="1">
          Retur
        </v-col>  
        <v-col cols="1">
          Mottagit
        </v-col>              
        <v-col cols="2">
          Reklamerat
        </v-col>      
      </v-row>                      
      
      <template v-for="(bundle) in insertBundle">
        <BundleHistoric :key="bundle.returnReport.id" :bundle="bundle" />        
      </template>            
    </v-container>
    <v-container v-else-if="!loading && insertBundle.length === 0 && paperBundle.length === 0">
      <h3>Inget att rapportera</h3>
    </v-container>   
    <v-container v-else-if="loading">
      <v-overlay>
        <v-row class="fill-height"
               align-content="center"
               justify="center"
        >
          <v-col
            class="text-subtitle-1 text-center"
            cols="12"
          >
            Hämtar data...
          </v-col>
          <v-col cols="12">
            <v-progress-linear
              color="primary"
              indeterminate
              rounded
              height="6"
            />
          </v-col>
        </v-row>        
      </v-overlay>
    </v-container>   
  </v-card>
</template>

<script>
import log from '@/logger'
import api from '@/backend/api'
import { orderBy} from 'lodash'
import BundleHistoric from '@/components/web/BundleHistoric'

export default {
  name:'Historic',
  components:{ BundleHistoric },
  data(){
    return {
      bundles:[],
      loading:true,
      dates: [],
      modal:false
    }
  },
  computed:{
    validDates(){
      if(this.dates[0] === undefined || this.dates[1] === undefined ){
        return false
      }
      var d1 = Date.parse(this.dates[0])
      var d2 = Date.parse(this.dates[1])
      return d1 < d2
    },
    dateRangeText () {
      return this.dates.join(' ~ ')
    },
    paperBundle(){
      return orderBy(this.bundles.filter(f=>f.type === 0), ['returnReport.paper.deliveryDate'],['desc'])
    },
    insertBundle(){
      return orderBy(this.bundles.filter(f=>f.type === 1), ['returnReport.paper.deliveryDate'],['desc'])
    },
    minDate(){
      var d= new Date()
      d.setMonth(d.getMonth() - 3)

      return d.toISOString().substr(0, 10)
    },
    maxDate(){
      return new Date().toISOString().substr(0, 10)
    }
  },
  mounted(){
    var d= new Date()
    this.dates = new Array(2)
    this.dates[1]= d.toISOString().substr(0, 10)
    d.setMonth(d.getMonth() - 1)
    this.dates[0] = d.toISOString().substr(0, 10)
    this.getData()
  },
  methods:{
    getNewData(dates){
      this.$refs.dialog.save(dates)
      this.getData()
    },
    getData(){
      api.getHistoricBundles(this.dates).then(resp => {     
        log.debug('Got bundle blocks ', resp.data)  
          this.bundles = resp.data
          this.loading = false
        })   
    }
  }
}
</script>